module.exports = __webpack_public_path__ + "media/images/emblems/GX-VS-Verossaz-b9f7592de8a95c16fa814fbfae90e085.png";